import { i18n } from '@/plugins/i18n'

export const requestStatus = {
    CREATED:        0,
    FINAL_REJECT:   5,
    PENDING:        8,
    DELAY:          12,
    CONFIRMED:      14,
}

export const requestStatusStr = {
    CREATED:        i18n.t('dedicated_request_status.created'),
    FINAL_REJECT:   i18n.t('dedicated_request_status.final_reject'),
    PENDING:        i18n.t('dedicated_request_status.pending'),
    DELAY:          i18n.t('dedicated_request_status.delay'),
    CONFIRMED:      i18n.t('dedicated_request_status.confirmed'),

    get(status) {
        let status_str = null;

        Object.keys(requestStatus).forEach(item => {
            if(requestStatus[item] === status) {
                status_str = requestStatusStr[item];
            }
        });

        return status_str;
    }
}

export const requestVariant = status => {
    if(status === requestStatus.CONFIRMED)
        return 'success';

    if(status === requestStatus.FINAL_REJECT)
        return 'danger';

    if(status === requestStatus.PENDING || status === requestStatus.DELAY)
        return 'warning';

    return 'info';
}
